import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { useIntl } from 'react-intl';

import { handleSkipOnboardingStep } from '../../../helpers/Onboarding';

const OnboardingSkipButton = ({ isCompleted, slug }) => {
  const intl = useIntl();

  if (isCompleted) return null;

  return (
    <Button
      color="link"
      onClick={() => handleSkipOnboardingStep(slug)}
      size="sm"
      className="onboarding-step-collapse-button-skip"
    >
      <i className="fal fa-forward mr-1" />
      {intl.formatMessage({ defaultMessage: 'Skip this step' })}
    </Button>
  );
};

OnboardingSkipButton.propTypes = {
  slug: PropTypes.string.isRequired,
  isCompleted: PropTypes.bool.isRequired,
};

export default OnboardingSkipButton;
